import {
  Button,
  ButtonElementTypes,
  ButtonSizeMD,
  ButtonSkinSecondary,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import { ButtonPlacements, Carousel } from '@picsart/design-system/components/Carousel';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useWindowSize from 'hooks/useWindowSize';
import { MoreText } from '../../constants';
import Item from '../Item';
import type { SizesPostListType } from '../../types';

import useStyles from './styles';

type Props = {
  SizesList: SizesPostListType[];
};

const CarouselItem = ({ SizesList }: Props) => {
  const classes = useStyles();
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (width < 425) {
      setIsMobile(true);
      return;
    }
    setIsMobile(false);
  }, [width]);
  return (
    <div className={classes.root}>
      {SizesList.map((items, index) => {
        return (
          <div key={`${index}sizeItem`} className={classes.sizeItemWrapper}>
            <div className={classes.sizeItemHeader}>
              <p className={classes.sizeItemsTitle}>{items.SizesListTitle}</p>
              <Button
                size={ButtonSizeMD}
                variant={ButtonVariants.Text}
                skin={ButtonSkinSecondary}
                tag={ButtonElementTypes.Button}
                data-pulse-name={MoreText}
                onClick={() => navigate(items.SizesSeeMoreLink)}
              >
                {items.SizesSeeMoreText}
              </Button>
            </div>
            <Carousel
              isMultiSlide={!isMobile}
              hideArrows={isMobile}
              dataTestId="sizes-carousel"
              gap={Spacings.s24}
              buttonPlacement={ButtonPlacements.Overhang}
              className={classes.carouselItem}
            >
              {items?.sizes.map((item, itemIndex) => {
                return <Item key={`${itemIndex}szie`} sizeItem={item} data-testid={itemIndex} />;
              })}
            </Carousel>
          </div>
        );
      })}
    </div>
  );
};
export default CarouselItem;
